module.exports = __webpack_public_path__ + "fonts/lato-all-400-normal.3dc1eff.woff";